{
	"header": {
		"tag": "Tilisi",
		"title": "Asetukset",
		"description": "Tallenna sijaintisi ja yhteystietosi esitäyttämiseen uusissa ilmoituksissa."
	},
	"warning": {
		"usernameRequired": "Sinun täytyy asettaa käyttäjätunnus ennen kuin voit luoda ilmoituksen."
	},
	"form": {
		"username": "Käyttäjätunnus",
		"usernamePlaceholder": "Valitse yksilöllinen käyttäjätunnus",
		"usernameTaken": "Tämä käyttäjätunnus on jo käytössä. Valitse toinen.",
		"usernameRequired": "Käyttäjätunnus on pakollinen.",
		"usernameLength": "Käyttäjätunnuksen pituuden tulee olla 3–30 merkkiä.",
		"usernameInvalidChars": "Sallittuja merkkejä ovat kirjaimet, numerot, alaviiva ja yhdysviiva.",
		"shipsTo": "Toimitus",
		"shipsToOptions": {
			"pickup-only": "Nouto",
			"domestic": "Kotimaahan",
			"international": "Kansainvälisesti"
		},
		"country": "Maa",
		"selectCountry": "Valitse maa",
		"city": "Kaupunki / Alue",
		"selectCity": "Valitse kaupunki",
		"contactInfo": "Yhteystiedot",
		"contactPlaceholder": "Puhelin, sähköposti, Discord jne.",
		"save": "Tallenna asetukset",
		"saving": "Tallennetaan…"
	},
	"toasts": {
		"saved": "Asetukset tallennettu",
		"error": "Asetusten tallennus epäonnistui. Yritä uudelleen."
	}
}
